module.exports = __webpack_public_path__ + "img/logo-sc-halloween.47af1824.png";